import { FC, useEffect, useState } from 'react'
import { useForm, useFormState } from 'react-hook-form'
import clsx from 'clsx'

import ControllerBaseInput from 'components/form-parts/controller-hook-forms/controller-base-input/controller-base-input'
import Button from 'components/parts/button/button'
import useAlert from 'store/common/useAlert'

import { postAxiosSingle } from 'pages/api/axios'
import { emailValidation, FieldsNameVoc } from 'constants/auth/profile-data'
import { AlertType } from 'constants/alert'
import { apiPath } from 'constants/url'
import { SessionStorageKeys } from 'constants/storage'
import { defaultSubText, imgPath } from './data'
import { IAnyObj } from 'constants/types/common.types'
import ButtonThemes from 'components/parts/button/themes'

import styles from './email-subscription.module.scss'

interface IEmailSub {
  subscribeText?: IAnyObj
  modificator?: string
}

const EmailSubscription: FC<IEmailSub> = ({ subscribeText = defaultSubText, modificator }) => {
  const [isSubscribed, setIsSubscribed] = useState(false)
  const { setSingleAlert } = useAlert()

  const { title, subtitle } = subscribeText

  const onSubmit = async (values: any) => {
    try {
      const axiosData = await postAxiosSingle(`${apiPath}/users/subscribeDigest`, {}, values)

      if (axiosData.data) {
        const { status } = axiosData.data

        if (status) {
          sessionStorage.setItem(SessionStorageKeys.DIGEST_SUBSCRIBED, 'true')
          setIsSubscribed(true)

          setSingleAlert({
            type: AlertType.SUB_SUCCESS,
            id: `${AlertType.SUB_SUCCESS}_LINK`,
            text: status,
          })
        }
      } else if (axiosData.response) {
        const { data } = axiosData.response

        data &&
          setSingleAlert({
            type: AlertType.SUB_SUCCESS,
            id: `${AlertType.SUB_SUCCESS}_LINK`,
            text: data?.status,
          })
      }
    } catch (err) {
      console.warn(err)
    }
  }

  const { handleSubmit, control, clearErrors } = useForm({
    mode: 'onBlur',
  })

  const { errors } = useFormState({ control })

  useEffect(() => {
    sessionStorage.getItem(SessionStorageKeys.DIGEST_SUBSCRIBED) === 'true' && setIsSubscribed(true)
  }, [])

  return (
    <section className={clsx(styles.emailSubscription, modificator)}>
      <div className={styles.contentBg} style={{ backgroundImage: `url(${imgPath.email})` }} />
      <div className={styles.content}>
        <div className={styles.txtBlock}>
          <p className={styles.title}>{title}</p>
          {!isSubscribed ? (
            <p className={styles.subtitle}>{subtitle}</p>
          ) : (
            isSubscribed && (
              <p className={styles.subscribed}>
                Отлично! Теперь вы подписаны на еженедельную рассылку с материалами 😊
              </p>
            )
          )}
        </div>

        {!isSubscribed && (
          <form
            id="form"
            className={styles.emailBlock}
            onSubmit={handleSubmit(onSubmit)}
            autoComplete="on"
          >
            <div className={styles.inputBlock}>
              <ControllerBaseInput
                control={control}
                name={FieldsNameVoc.email}
                errors={errors}
                dynamicName
                noErrorOnTouch={clearErrors}
                rules={emailValidation}
              />
            </div>
            <div className={styles.btnBlock}>
              <Button modificator={styles.btn} theme={ButtonThemes.PURPLE} type="submit">
                Хочу
              </Button>
            </div>
          </form>
        )}
      </div>
    </section>
  )
}

export default EmailSubscription
